/**
 * @generated SignedSource<<b4da28d6b6270b83b2e7ee86bed6da90>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedLayout_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedTrackingContainer_user">;
  readonly " $fragmentType": "PdpSharedLayout_user";
};
export type PdpSharedLayout_user$key = {
  readonly " $data"?: PdpSharedLayout_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedLayout_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedLayout_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedTrackingContainer_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "4d055eca3cf7a8b680bf82157ea283dc";

export default node;
